export enum BookingMarketsDisabledAttribute {
  Master = 835,
}
